module.exports = __webpack_public_path__ + "img/CapyReads copy.0fae42d4.gif";